import { Modal } from 'ant-design-vue'
import { getCurrentLocale } from '@/i18n'

const locale = getCurrentLocale()

const textMap: any = {
  zh: {
    error: '出错了',
    success: '成功',
  },

  en: {
    error: 'Error',
    success: 'Success',
  }
}

const text = textMap[locale]

function getText() {
  return textMap[locale]
}

const showModal = (type: string, message: string, title: string) => {
  return new Promise(resolve => {
    ((Modal as any)[type])({
      title,
      content: message,
      onOk() {
        resolve()
      }
    })
  })
}

/**
 * 显示错误信息对话框
 * @param message 要显示的消息
 * @param title 标题，默认出错了
 */
export function alert(message: string, title = getText().error) {
  return showModal('error', message, title)
}

/**
 * 显示成功信息对话框
 * @param message 要显示的消息
 * @param title 标题，默认：成功
 */
export function success(message: string, title = getText().success) {
  return showModal('success', message, title)
}

/**
 * 显示 confirm
 * @param message 消息
 * @param title 标题
 */
export function confirm(message: string, title: string) {
  return showModal('confirm', message, title)
}
